import type * as React from 'react'

type AlgoAcademyHorizontalLogoProps = Omit<
  React.ComponentPropsWithoutRef<'img'>,
  'src' | 'alt' | 'width' | 'height'
>

export function AlgoAcademyHorizontalLogo({ className, ...props }: AlgoAcademyHorizontalLogoProps) {
  return (
    // biome-ignore lint/performance/noImgElement: the public SVG keeps the shared marketing logo out of every page's HTML
    <img
      {...props}
      src='/logos/algoacademy-horizontal-marketing.svg'
      alt=''
      aria-hidden='true'
      width={160}
      height={26}
      className={className}
    />
  )
}
